<template>
    <div class="p-0 m-0">
        <b-row class="justify-content-md-center">
            <b-button v-b-toggle="`collapse-` + data.ano" class="btn-timeline" @click="selectYear(data.ano)" :variant="selectedYear === data.ano ? 'primary' : 'secondary'">{{ data.ano }}</b-button>
        </b-row>
        <b-collapse :id="`collapse-` + data.ano">
            <section class="timeline">
                <div v-for="mes in data.meses" :key="mes.mes">
                    <b-row class="justify-content-md-center">
                        <b-button v-b-toggle="`collapse-month-` + data.ano + mes.mes" class="btn-sub-timeline timeline-item-month" variant="primary">{{ mes.mes }}</b-button>
                    </b-row>
                    <div class="container">
                        <b-collapse visible :id="`collapse-month-` + data.ano + mes.mes" class="mt-2">
                            <div v-for="dia in mes.dias" :key="dia.dia" class="timeline-item">
                                <div class="timeline-img">
                                    <b-row class="mt-1 timeline-day justify-content-md-center">
                                        {{ dia.dia }}
                                    </b-row>
                                </div>
                                <div class="timeline-content p-0 m-0">
                                    <b-table borderless striped small :items="dia.items" :fields="fields">
                                    </b-table>
                                </div>
                            </div>
                        </b-collapse>
                    </div>
                </div>
            </section>
        </b-collapse>
    </div>
</template>

<script>
export default {
    props: ['data'],
    name: "Timeline",
    data() {
        return {
            selectedYear: null,
            fields: [
                {
                    key: 'hora',
                    label: 'Hora',
                    class: 'text-center'
                },
                {
                    key: 'evento',
                    label: 'Evento',
                },
                {
                    key: 'usuario',
                    label: 'Usuário',
                    class: 'text-center'
                }
            ],
        }
    },
    methods: {
        selectYear(year) {
            if(this.selectedYear === year) {
                this.selectedYear = null
            } else {
                this.selectedYear = year
            }
        }
    }
};
</script>

<style scoped>


.timeline {
  position: relative;
}
.timeline::before {
  content: '';
  background: #CECECE;
  width: 5px;
  height: 95%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.timeline-item {
  width: 100%;
  margin-bottom: 70px;
}

.timeline-item:nth-child(even) .timeline-content {
  float: right;
}

.timeline-item:nth-child(even) .timeline-content .date {
  right: auto;
  left: 0;
}

.timeline-item:nth-child(even) .timeline-content::after {
  content: '';
  position: absolute;
  border-style: solid;
  width: 0;
  height: 0;
  top: 6px;
  left: -15px;
  border-width: 10px 15px 10px 0;
  border-color: transparent #F0F3F5 transparent transparent;
}
.timeline-item::after {
  content: '';
  display: block;
  clear: both;
}

.timeline-content {
  position: relative;
  width: 45%;
  padding: 10px 13px 10px 10px;
  border-radius: 4px;
  background: none;
  top: 10px;
}
.timeline-content::after {
  content: '';
  position: absolute;
  border-style: solid;
  width: 0;
  height: 0;
  top: 6px;
  right: -15px;
  border-width: 10px 0 10px 15px;
  border-color: transparent transparent transparent #F0F3F5;
}

.timeline-img {
  width: 30px;
  height: 30px;
  background: #20a8d8;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  margin-top: 15px;
  margin-left: -15px;
}

.timeline-day {
    color: #FFF;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
}

.btn-timeline {
    margin-bottom: 10px;
    width: 20%;
}

.btn-sub-timeline {
    margin-bottom: 10px;
    width: 10%;
}

.timeline-item-month {
    color: #FFF;
    z-index: 100;
    background-color: #20a8d8;
    padding: 10px;
    border-radius: 5px;
    font-weight: bold;
}

</style>